import { Module } from '@nestjs/common';
import { PersonasModule } from 'src/personas/personas.module';
import { TransportistasController } from './transportistas.controller';
import { TransportistasService } from './transportistas.service';

@Module({
  imports: [PersonasModule],
  controllers: [TransportistasController],
  providers: [TransportistasService],
  exports: [TransportistasService],
})
export class TransportistasModule {}
